module.exports = __webpack_public_path__ + "static/media/Close.58133b5a.svg";